import { useTranslation } from 'react-i18next';
import { AdmissionType } from '@domain/admission';
import { getDefaultOfferNameTranslation } from '@utils/get-default-offer-name-translation/get-default-offer-name-translation';
import { getTranslatedPropertyBasedOnOrder } from '@utils/get-translated-property-based-on-order/get-translated-property-based-on-order';

import type { SummaryTableProps } from './summary-table.type';
import { SummaryTableBody } from './summary-table-body';

export const SummaryTable = ({ quantity, offer, addons, formAddons, fullName, isInvitation }: SummaryTableProps) => {
  const { t, i18n } = useTranslation();

  const offerName =
    getTranslatedPropertyBasedOnOrder({
      translations: offer?.name,
      preferredLanguage: i18n.language,
    }) ?? t(getDefaultOfferNameTranslation(offer.admissionType as AdmissionType));

  return (
    <section className='flex-col justify-start items-center flex w-full rounded-lg mb-6 sm:mb-8'>
      <SummaryTableBody
        fullName={fullName}
        quantity={quantity}
        offer={offer}
        addons={addons}
        formAddons={formAddons}
        offerName={offerName}
        isInvitation={isInvitation}
      />
    </section>
  );
};
